import { api } from "../../../utility/AxiosInceptor";
import { createAsyncThunk } from "@reduxjs/toolkit";

//add template action
export const addTemplateAction = createAsyncThunk(
  "notification/api/sms/addTemplate",
  async (body, { rejectWithValue }) => {
    try {
      const response = await api.post(`/api/sms/addTemplate`, body);
      // if (response.status === 200) {
      //     Toasts({ success: `Template ${response.data.msg}` });
      //      return response.data;

      // }
      return response;
    } catch (error) {
      if (error.response && error.data.response.message) {
        return rejectWithValue(error.data.response.message);
      } else {
        rejectWithValue(error.message);
      }
    }
  }
);

//get list of all templates action
export const getAllTemplateAction = createAsyncThunk(
  "notification/sms/template/draft",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/api/sms/template/all?userId=645a85198cd1ff499c8b99cd`
      );
      return response.data;
    } catch (error) {
      debugger;
      if (error.response && error.data.response.message) {
        return rejectWithValue(error.data.response.message);
      } else {
        rejectWithValue(error.message);
      }
    }
  }
);

//get one template action
export const getOneTemplateAction = createAsyncThunk(
  `notification/sms/template/${1}`,
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/sms/template/${id}`);
      return response.data;
    } catch (error) {
      if (error.response && error.data.response.message) {
        return rejectWithValue(error.data.response.message);
      } else {
        rejectWithValue(error.message);
      }
    }
  }
);

//get all sent templates action
export const getSentAllTemplateAction = createAsyncThunk(
  "notification/sms/template/sent",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/sms/template/sent`);
      return response.data;
    } catch (error) {
      if (error.response && error.data.response.message) {
        return rejectWithValue(error.data.response.message);
      } else {
        rejectWithValue(error.message);
      }
    }
  }
);

//show all sent data action
export const getSentByTemplateIdAction = createAsyncThunk(
  "notification/sms/sent",
  async (body, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/api/sms/sent?templateId=${body.templateId}&company=${body.company}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.data.response.message) {
        return rejectWithValue(error.data.response.message);
      } else {
        rejectWithValue(error.message);
      }
    }
  }
);

//send template action
export const submitTemplateAction = createAsyncThunk(
  "notification/sms/send",
  async (body, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/api/sms/send?sentBy=${body.userId}&templateId=${body.templateId}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.data.response.message) {
        return rejectWithValue(error.data.response.message);
      } else {
        rejectWithValue(error.message);
      }
    }
  }
);

//show all draft data action
export const getDraftByTemplateIdAction = createAsyncThunk(
  "notification/sms/draft",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/sms/draft?templateId=${id}`);
      return response.data;
    } catch (error) {
      if (error.response && error.data.response.message) {
        return rejectWithValue(error.data.response.message);
      } else {
        rejectWithValue(error.message);
      }
    }
  }
);
